import { API } from "."
import type {
  FilterPreset,
  FilterPresetSummary,
  UpsertFilterPresetPayload,
} from "@/types/filterPreset"

const BASE_PATH = "/settings/report/filter-presets"

/** 프리셋 목록 조회 */
export async function readFilterPresets() {
  return await API.get<FilterPresetSummary[]>(BASE_PATH)
}

/** 프리셋 상세 조회 */
export async function readFilterPresetDetail(idfPreset: number) {
  return await API.get<FilterPreset>(`${BASE_PATH}/${idfPreset}`)
}

/** 프리셋 생성 */
export async function createFilterPreset(payload: UpsertFilterPresetPayload) {
  return await API.post<FilterPreset>(BASE_PATH, payload)
}

/** 프리셋 수정 */
export async function updateFilterPreset(idfPreset: number, payload: UpsertFilterPresetPayload) {
  return await API.put<FilterPreset>(`${BASE_PATH}/${idfPreset}`, payload)
}

/** 프리셋 삭제 */
export async function deleteFilterPreset(idfPreset: number) {
  return await API.delete(`${BASE_PATH}/${idfPreset}`)
}
